module.exports = __webpack_public_path__ + "media/images/front/sp/article/doctor03-1bae9d07c83db0784e98d06665aff353.png";